import React, { useEffect, useState } from 'react';
import { FormControl, Grid, GridSize, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { InfluencerAuxiliarModel } from '../../../Models/InfluencerAuxiliarModel';

interface props {
    items: InfluencerAuxiliarModel[],
    selectValue: number | undefined | null,
    Title: string,
    size?: boolean | GridSize | undefined;
    setSelectValue(props: number | undefined): void
}
export default function InfluencerClassificationFilters({ items, Title, selectValue, setSelectValue, size = 2 }: props) {

    // Para manter o valor selecionado sincronizado
    const [internalValue, setInternalValue] = useState<InfluencerAuxiliarModel | null>(
        Array.isArray(items) ? items.find((item) => item.id_aux === selectValue) || null : null
    );

    useEffect(() => {
        setInternalValue(Array.isArray(items) ? items.find((item) => item.id_aux === selectValue) || null : null);
    }, [selectValue, items]);

    return (
        <Grid item xs={size}>
            <Grid
                container
                style={{
                    marginTop: '0.5rem',
                    marginBottom: '0.5rem',
                    padding: '8px',
                }}
            >
                <FormControl variant="standard" style={{ width: '100%' }}>
                    <Autocomplete
                        id={`autocomplete-${Title}`}
                        options={items || []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={internalValue}
                        onChange={(_, newValue) => {
                            setInternalValue(newValue);
                            setSelectValue(newValue ? newValue.id_aux : undefined);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={Title}
                                variant="outlined"
                                fullWidth
                            />
                        )}
                        clearOnEscape
                        getOptionSelected={(option: InfluencerAuxiliarModel, value: InfluencerAuxiliarModel) => option.id_aux === value.id_aux}
                    />
                </FormControl>
            </Grid>
        </Grid>
    );
}